import type GalileoAegis from '@tencent/aegis-web-sdk-v2';

interface MonitoringEventPayload {
  name: string;
  ext1?: string;
  ext2?: string;
  ext3?: string;
  ext4?: string;
  ext5?: string;
  ext6?: string;
  ext7?: string;
  ext8?: string;
  ext9?: string;
  ext10?: string;
  from?: string;
  page_url?: string;
}

export type MonitoringEvent = string | MonitoringEventPayload;

type GalileoMonitoringClient = Pick<GalileoAegis, 'reportEvent' | 'error' | 'setConfig'>;

export interface MonitoringReporter {
  reportEvent(event: MonitoringEvent): void;
  error(...messages: unknown[]): void;
  setUser(userName: string): void;
}

export function warnMonitoringFailure(operation: 'initialization' | keyof MonitoringReporter, error: unknown): void {
  // 监控链路异常不能影响业务，也不能再次走监控形成递归。
  try {
    console.warn(`[monitoring] ${operation} failed`, error);
  } catch {
    // 宿主替换的 console 不应把监控故障扩散出去。
  }
}

export function createMonitoringReporter(client: GalileoMonitoringClient | null): MonitoringReporter {
  const invoke = (method: keyof MonitoringReporter, action: (client: GalileoMonitoringClient) => unknown): void => {
    if (client === null) return;
    try {
      void Promise.resolve(action(client)).catch(error => warnMonitoringFailure(method, error));
    } catch (error) {
      warnMonitoringFailure(method, error);
    }
  };

  return {
    reportEvent(event) {
      invoke('reportEvent', client => client.reportEvent(event));
    },
    error(...messages) {
      invoke('error', client => client.error(...messages));
    },
    setUser(userName) {
      invoke('setUser', client => client.setConfig({ uid: userName }));
    },
  };
}
